module.exports = __webpack_public_path__ + "img/Weapon_268.8fa8b1a5.png";